// extracted by mini-css-extract-plugin
module.exports = {"showcase":"Showcase_showcase__36Ymu","title":"Showcase_title__20XuL","textIntro":"Showcase_textIntro__2thRe","text":"Showcase_text__1y_Kc","image":"Showcase_image__2E8h9"};